import React from 'react';
import { Users } from 'lucide-react';
import FrequentPlayersList from '../../../components/FrequentPlayersList';
import { useTheme } from '../../../contexts/ThemeContext';

interface PlayersViewProps {
  userId: string;
}

const PlayersView: React.FC<PlayersViewProps> = ({ userId }) => {
  const { theme } = useTheme();

  return (
    <div className={`space-y-6 ${theme === 'dark' ? 'text-gray-300' : 'text-gray-900'}`}>
      <div className="flex flex-col md:flex-row items-start gap-4">
        <div className="w-full md:w-2/3">
          {/* Lista de Jogadores Frequentes */}
          <FrequentPlayersList limit={10} /> {/* Aumenta limite opcionalmente */}
        </div>
        <div className="w-full md:w-1/3">
          {/* Card Informativo */}
          <div className={`rounded-lg shadow p-3 sticky top-4 ${theme === 'dark' ? 'bg-gray-800 border border-gray-700' : 'bg-white'}`}>
            <h3 className={`text-lg font-medium mb-3 flex items-center ${theme === 'dark' ? 'text-gray-100' : 'text-gray-900'}`}>
              <Users className={`h-5 w-5 mr-2 ${theme === 'dark' ? 'text-indigo-400' : 'text-indigo-500'}`} />
              Gerenciando Jogadores
            </h3>
            <p className={`text-sm mb-3 ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
              Registre as pessoas com quem você joga para facilitar a marcação de partidas e ver estatísticas compartilhadas.
            </p>
            <div className={`rounded-lg p-3 mb-3 ${theme === 'dark' ? 'bg-gray-700' : 'bg-gray-50'}`}>
              <p className={`text-sm font-medium mb-2 ${theme === 'dark' ? 'text-gray-200' : 'text-gray-700'}`}>
                Como funciona:
              </p>
              <ul className={`list-disc list-inside text-sm space-y-1 ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
                <li>Adicione amigos ou contatos manuais.</li>
                <li>Ao registrar uma partida, selecione quem jogou com você.</li>
                <li>O sistema identificará automaticamente seus parceiros frequentes.</li>
                <li>Veja estatísticas de jogos jogados em conjunto.</li>
              </ul>
            </div>
             {/* Botão para gerenciar conexões/jogadores manuais pode ser adicionado aqui */}
             {/* Exemplo: <button className="..." onClick={() => navigate('/connections')>Gerenciar Contatos</button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlayersView; 